<div class="container-fluid mt-3 mb-3">
    <mat-card>
        <div class="row">
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        </div>
        <mat-card-header>
            <mat-card-title class="d-flex align-items-center">
                <mat-icon color="primary" class="me-2">schedule</mat-icon>
                Booking Durations
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="pt-3">
            <p class="text-muted mb-3">
                Manage the available booking durations for your customers. These durations will appear as options when customers create bookings.
            </p>

            <!-- Quick Add Button -->
            <div class="row mb-3">
                <div class="col-12">
                    <button mat-stroked-button color="accent" 
                            (click)="addStandardDurations()"
                            [disabled]="isLoading">
                        <mat-icon>flash_on</mat-icon>
                        Quick Add Standard Durations
                    </button>
                    <small class="text-muted ms-2">Adds: 30min, 1hr, 1.5hr, 2hr, 2.5hr, 3hr, 3.5hr, 4hr</small>
                </div>
            </div>
            
            <!-- Add New Duration Form -->
            <form [formGroup]="durationForm" (ngSubmit)="addBookingDuration()">
                <div class="row mb-4 align-items-center">
                    <div class="col-md-4">
                        <mat-form-field class="w-100">
                            <mat-label>Duration {{ useHours ? '(hours)' : '(minutes)' }}</mat-label>
                            <input matInput type="number" formControlName="duration"
                                   [min]="useHours ? 0.5 : 30" 
                                   [step]="useHours ? 0.5 : 30" 
                                   [placeholder]="useHours ? 'e.g., 1.5' : 'e.g., 60'">
                            <mat-hint>{{ useHours ? 'Enter duration in hours (minimum 0.5)' : 'Enter duration in minutes (minimum 30)' }}</mat-hint>
                            <mat-error *ngIf="durationForm.get('duration').errors?.required">
                                Duration is required
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2 d-flex align-items-center">
                        <button mat-raised-button color="primary" 
                                type="submit"
                                [disabled]="!durationForm.valid || isLoading">
                            <mat-icon>add</mat-icon>
                            Add Duration
                        </button>
                    </div>
                    <div class="col-md-3 d-flex align-items-center">
                        <mat-slide-toggle [(ngModel)]="useHours" [ngModelOptions]="{standalone: true}" (change)="onInputModeChange()">
                            Enter in hours
                        </mat-slide-toggle>
                    </div>
                </div>
            </form>
            
            <!-- Error Message -->
            <div class="alert alert-danger" *ngIf="bookingDurationErrorMessage">
                {{ bookingDurationErrorMessage }}
            </div>
            
            <!-- Durations Table -->
            <div class="row" *ngIf="bookingDurations && bookingDurations.length > 0">
                <div class="col-12">
                    <h6 class="mb-3">Available Durations:</h6>
                    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-100">
                        <ng-container matColumnDef="duration">
                            <th mat-header-cell *matHeaderCellDef>Duration</th>
                            <td mat-cell *matCellDef="let row">
                                <span [class.text-muted]="!row.isEnabled">{{ formatDuration(row.durationMinutes) }}</span>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="enabled">
                            <th mat-header-cell *matHeaderCellDef>Enabled</th>
                            <td mat-cell *matCellDef="let row">
                                <mat-slide-toggle [(ngModel)]="row.isEnabled" 
                                                  (change)="toggleEnabled(row)"
                                                  [disabled]="isLoading">
                                </mat-slide-toggle>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let row">
                                <button mat-icon-button class="warning" 
                                        (click)="removeBookingDuration(row)"
                                        [disabled]="isLoading"
                                        matTooltip="Remove duration">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
            
            <!-- Empty State -->
            <div class="row" *ngIf="!bookingDurations || bookingDurations.length === 0">
                <div class="col-12 text-center py-4">
                    <mat-icon color="accent" style="font-size: 48px; width: 48px; height: 48px;">schedule</mat-icon>
                    <p class="text-muted mt-2">No custom booking durations configured yet. Add your first duration above.</p>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
